module.exports = __webpack_public_path__ + "static/media/stage_stub.a38e4749.svg";